import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {AccessRights, PARTS} from '../../schemas/accessRightsModel';

import {
  updateVisualizerManagement,
  updateDeleteList,
  getVisualizerManagementMenu,
} from './VisualizerManagementActions';
import template from './VisualizerManagementMenu.rt';
import {errorBox_Show} from "../../actions/A_Popups";
import {VISUALIZER_TYPES} from "../../constants/dashboard";
import {hasSubscriptions} from "../../utilities/subscriptionFunctions";

class visualizerManagementMenu extends Component {

  static propTypes = {
    mobileMenu: PropTypes.array
  };

  componentDidMount() {
    this.props.getVisualizerManagementMenu();
  }

  handleAddBVLink = () => {
    if (!this.props.AR.e(PARTS.VIS_MNGM_NEW_LINKS)) {
      return false
    }
    this.handleAddLink(VISUALIZER_TYPES.bathroom, this.props.mobileBVMenu)
  };

  handleAddLink = (forTool = VISUALIZER_TYPES.kitchen, newMenu = this.props.mobileMenu) => {
    if (newMenu.length) {
      const lastMenu = newMenu[newMenu.length - 1];
      if (lastMenu.name.trim().length === 0 ||
        lastMenu.url.trim().length === 0) {
        this.props.errorBox_Show({
          title: 'Error',
          text: 'URL and name must have a value.',
          rightButtonText: 'OK',
          isRightButtonVisible: true
        });
        return;
      }
    }
    newMenu.push({
      fabricatorId: this.props.fabricatorId,
      name: "",
      url: "",
      displayOrder: newMenu.length,
      forTool
    });
    this.props.updateVisualizerManagement(newMenu, forTool);
  };

  handleChangeBVLink = (e, type, index) => {
    this.handleChangeLink(e, type, index, this.props.mobileBVMenu, VISUALIZER_TYPES.bathroom)
  };

  handleChangeLink = (e, type, index, newMenu = this.props.mobileMenu, forTool = VISUALIZER_TYPES.kitchen) => {
    newMenu[index][type] = e.target.value;
    this.props.updateVisualizerManagement(newMenu, forTool);
  };

  handleDeleteBVLink = (index) => this.handleDeleteLink(index, this.props.mobileBVMenu, VISUALIZER_TYPES.bathroom);

  handleDeleteLink = (index, newMenu = this.props.mobileMenu, forTool = VISUALIZER_TYPES.kitchen) => {
    let deletedMenu = newMenu.splice(index, 1);
    if (deletedMenu.length === 1) {
      this.props.updateDeleteList(deletedMenu[0]);
    }
    this.props.updateVisualizerManagement(newMenu, forTool);
  };

  handleSwapBVPlaces = (index1, index2) => {
    this.handleSwapPlaces(index1, index2, this.props.mobileBVMenu, VISUALIZER_TYPES.bathroom)
  };

  handleSwapPlaces = (index1, index2, newMenu = this.props.mobileMenu, forTool = VISUALIZER_TYPES.kitchen) => {
    const temp = newMenu[index1];
    newMenu[index1] = newMenu[index2];
    newMenu[index2] = temp;
    this.props.updateVisualizerManagement(newMenu, forTool);
  };

  render = template

}

const mapStateToProps = state => {
  const {auth} = state;
  const {hasKitchen, hasBathroom, hasFireplace,  hasLaundryRoom,
    allSubscriptions} = hasSubscriptions(state);
  return {
    hasKitchen,
    hasBathroom,
    hasFireplace,
    hasLaundryRoom,
    allSubscriptions,
    mobileMenu: [...state.visualizerManagement.mobileMenu],
    mobileBVMenu: [...state.visualizerManagement.mobileBVMenu],
    fabricatorId: auth.fabricator,
    AR: AccessRights.get(state)
  }
};

const mapDispatchToProps = {
  getVisualizerManagementMenu,
  updateVisualizerManagement,
  updateDeleteList,
  errorBox_Show,
};

const VisualizerManagementMenu = connect(mapStateToProps, mapDispatchToProps)(visualizerManagementMenu);
export { VisualizerManagementMenu };
